import i18next, { t } from 'i18next';
import fiestaLogo from 'src/assets/images/fiesta-logo.png';

export default function FooterComponent() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="foot">
      <div className="wrap foot__row">
        <a className="wordmark" href="#home">
          <img src={fiestaLogo} alt="FIESTA" style={{ height: '40px', width: 'auto' }} />
        </a>
        <div className="foot__socials">
          <a href="https://www.instagram.com/join.fiesta" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="18" height="18" rx="5" />
              <circle cx="12" cy="12" r="4" />
              <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" stroke="none" />
            </svg>
          </a>
          <a href="https://www.tiktok.com/@join.fiesta" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
            </svg>
          </a>
        </div>
        <div className="foot__nav">
          <span className="foot__lang">
            {['en', 'de', 'fr'].map(lang => (
              <button
                key={lang}
                aria-pressed={i18next.language?.startsWith(lang) ? true : false}
                onClick={() => i18next.changeLanguage(lang)}
              >
                {lang.toUpperCase()}
              </button>
            ))}
          </span>
          <a href="https://superfans.social/imprint" target="_blank" rel="noopener noreferrer">
            {t('joinPage.v2.footer.imprint')}
          </a>
          <a href="https://superfans.social/privacy-policy" target="_blank" rel="noopener noreferrer">
            {t('joinPage.v2.footer.privacy')}
          </a>
        </div>
        <div className="foot__legal">
          © {currentYear} Superfans GmbH. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
